<div class="loyalty-program-details" [class.compact]="loyaltyProgramDetails.steps.length > 5">
  <div class="loyalty-program-details-header">
    <ion-button color="light" size="small" class="loyalty-program-details-reload-button" (click)="onRequestReload()">
      <ion-icon
        name="reload"
        slot="icon-only"
        class="loyalty-program-details-reload-button-icon"
        [class.animated]="isReloadingDetails"
      ></ion-icon>
    </ion-button>

    <p class="loyalty-program-details-title">
      {{ loyaltyProgramDetails.name ? loyaltyProgramDetails.name : ("LOYALTY_PROGRAM_STATUS_COMPONENT.TITLE" | translate) }}
    </p>
    <p tappable class="loyalty-program-details-description" (click)="onOpenTermsAndConditionsModal()">
      {{ "LOYALTY_PROGRAM_STATUS_COMPONENT.DESCRIPTION" | translate }}<span class="loyalty-program-details-description-divider"> • </span>

      <span class="loyalty-program-details-deadline badge">
        <span
          class="loyalty-program-details-deadline-text"
          [innerHTML]="'LOYALTY_PROGRAM_STATUS_COMPONENT.DEADLINE' | translate : { dateTimeText: deadlineDateTimeText }"
        ></span>
      </span>

      <span tappable class="loyalty-program-details-terms-and-conditions">{{
        "LOYALTY_PROGRAM_STATUS_COMPONENT.TERMS_AND_CONDITIONS" | translate
      }}</span>
    </p>
  </div>
  <div class="loyalty-program-details-deadline">
    <span
      class="loyalty-program-details-deadline-text"
      [innerHTML]="'LOYALTY_PROGRAM_STATUS_COMPONENT.DEADLINE' | translate : { dateTimeText: deadlineDateTimeText }"
    ></span>
  </div>
  <div class="loyalty-program-details-content" [class.reloading]="isReloadingDetails">
    <ion-button color="light" size="small" class="loyalty-program-details-reload-button" (click)="onRequestReload()">
      <ion-icon
        name="reload"
        slot="icon-only"
        class="loyalty-program-details-reload-button-icon"
        [class.animated]="isReloadingDetails"
      ></ion-icon>
    </ion-button>

    <div class="loyalty-program-details-images">
      <div
        tappable
        *ngFor="let step of loyaltyProgramDetails.steps; let i = index"
        class="loyalty-program-details-image"
        (click)="onOpenRewardDetails(i)"
      >
        <div class="loyalty-program-details-image-aspect-ratio-wrapper">
          <div class="loyalty-program-details-image-aspect-ratio-content">
            <app-animated-image [imageUrl]="step.imageUrl"></app-animated-image>
          </div>
        </div>
      </div>
    </div>

    <div class="loyalty-program-details-rewards-wrapper">
      <div class="loyalty-program-details-rewards">
        <div
          tappable
          *ngFor="let step of loyaltyProgramDetails.steps; let i = index"
          class="loyalty-program-details-reward"
          (click)="onOpenRewardDetails(i)"
        >
          <div
            class="loyalty-program-details-reward-content"
            [class.first]="i === 0"
            [class.last]="i === loyaltyProgramDetails.steps.length - 1"
            [class.unknown]="step.status === LoyaltyProgramStepStatus.Unknown"
            [class.in-progress]="step.status === LoyaltyProgramStepStatus.InProgress"
            [class.completed]="step.status === LoyaltyProgramStepStatus.Completed"
          >
            <span>{{ step.rewardText || "" }}</span>
          </div>

          <div
            *ngIf="i === currentStepIndex"
            class="loyalty-program-details-rewards-handle-wrapper"
            [class.at-start]="loyaltyProgramDetails.steps[currentStepIndex].status === LoyaltyProgramStepStatus.Unknown"
            [class.at-end]="loyaltyProgramDetails.steps[currentStepIndex].status !== LoyaltyProgramStepStatus.Unknown"
          >
            <div
              class="loyalty-program-details-rewards-handle"
              [class.success]="loyaltyProgramDetails.steps[currentStepIndex].status === LoyaltyProgramStepStatus.Completed"
              [class.success-animated]="loyaltyProgramDetails.steps[currentStepIndex].status === LoyaltyProgramStepStatus.InProgress"
            >
              <div class="loyalty-program-details-rewards-handle-content">
                <div class="loyalty-program-details-rewards-handle-icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loyalty-program-details-orders">
      <div
        tappable
        *ngFor="let step of loyaltyProgramDetails.steps; let i = index"
        class="loyalty-program-details-order"
        (click)="onOpenRewardDetails(i)"
      >
        <p class="loyalty-program-details-order-name">
          {{ "LOYALTY_PROGRAM_STATUS_COMPONENT.ORDER_COUNT" | translate : { orderCount: (step.orderCount | ordinalFormat) } }}
        </p>
        <p class="loyalty-program-details-order-status">{{ step.statusText }}</p>
      </div>
    </div>
  </div>
</div>
